/* =========================================================
   VitaDoza — Favorilerim
   Empty-state controller — production v19.2
   ========================================================= */

(function () {
  'use strict';

  var PAGE_SELECTOR = '.vd-wishlist-page';
  var SOURCE_SELECTOR = '[data-vd-empty-support]';
  var CALLOUT_SELECTOR = '.wk-wishlist-empty-callout';
  var CTA_SELECTOR = '.wk-callout-cta';
  var SUPPORT_CLASS = 'vd-wishlist-empty-support';

  function syncSupportText(page) {
    if (!page) return;

    var source = page.querySelector(SOURCE_SELECTOR);
    var callout = page.querySelector(CALLOUT_SELECTOR);

    if (!callout) return;

    var text = source ? (source.textContent || '').trim() : '';
    var existing = callout.querySelector('.' + SUPPORT_CLASS);

    if (!text) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('p');
      existing.className = SUPPORT_CLASS;
      existing.setAttribute('role', 'note');
    }

    if (existing.textContent !== text) {
      existing.textContent = text;
    }

    var cta = callout.querySelector(CTA_SELECTOR);

    if (cta) {
      var correctlyPlaced =
        existing.parentElement === callout &&
        existing.previousElementSibling === cta;

      if (!correctlyPlaced) {
        cta.insertAdjacentElement('afterend', existing);
      }
    } else if (existing.parentElement !== callout) {
      callout.appendChild(existing);
    }
  }

  function initPage(page) {
    if (!page) return;

    syncSupportText(page);

    if (page.dataset.vdEmptyObserver === 'true') return;
    page.dataset.vdEmptyObserver = 'true';

    var scheduled = false;

    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;
        syncSupportText(page);
      });
    });

    observer.observe(page, {
      childList: true,
      subtree: true
    });
  }

  function initAll() {
    document.querySelectorAll(PAGE_SELECTOR).forEach(initPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
